import {defineStore} from 'pinia';

export const useUserStore = defineStore('userStore', {
    state: () => ({
        email: null as string | null,
    }),
    actions: {
        login(email: string|null) {
            this.email = email;
            localStorage.setItem('userEmail', email!);
        },
        logout() {
            this.email = null;
            localStorage.removeItem('userEmail');
        },
        checkLogin() {
            const storedEmail = localStorage.getItem('userEmail');
            if (!storedEmail) {
                this.logout();
                return false;
            } else {
                this.email = storedEmail;
                return true
            }
        }
    }
});